var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 257.69,
    y2: 551.34
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.78,
    x2: 285.509,
    xlinkHref: "#lg2",
    y1: 356.956,
    y2: 17.433
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.451,
    x2: 276.956,
    xlinkHref: "#lg2",
    y1: 400.346,
    y2: 158.016
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 432.374,
    y2: 487.52
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.473,
    x2: 455.951,
    xlinkHref: "#lg1",
    y1: 166.186,
    y2: 181.664
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 487.212,
    x2: 502.098,
    xlinkHref: "#lg1",
    y1: 188.971,
    y2: 203.857
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 475.366,
    x2: 483.946,
    xlinkHref: "#lg1",
    y1: 149.937,
    y2: 158.517
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.993,
    x2: 350.763,
    xlinkHref: "#lg1",
    y1: 154.122,
    y2: 171.892
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.199,
    x2: 353.097,
    xlinkHref: "#lg1",
    y1: 182.124,
    y2: 190.022
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.071,
    x2: 203.652,
    xlinkHref: "#lg1",
    y1: 60.41,
    y2: 81.971
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.058,
    x2: 220.104,
    xlinkHref: "#lg2",
    y1: 70.38,
    y2: 34.274
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.237,
    x2: 260.747,
    xlinkHref: "#lg1",
    y1: 64.77,
    y2: 115.28
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.317,
    x2: 212.224,
    xlinkHref: "#lg2",
    y1: 94.079,
    y2: 45.142
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.461,
    x2: 223.159,
    xlinkHref: "#lg2",
    y1: 87.133,
    y2: 97.352
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-.006 1 1 .006 -391.894 -669.076)",
    gradientUnits: "userSpaceOnUse",
    x1: 687.025,
    x2: 713.699,
    xlinkHref: "#lg1",
    y1: 636.799,
    y2: 636.799
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.129,
    x2: 191.757,
    y1: 76.833,
    y2: 76.833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.933,
    x2: 257.933,
    y1: 137.686,
    y2: 253.402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ca1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#537983"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.873,
    x2: 63.54,
    y1: 227.481,
    y2: 257.814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.285,
    x2: 148.571,
    y1: 218.158,
    y2: 228.444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.539,
    x2: 428.539,
    y1: 232.982,
    y2: 183.982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m462.111 224.105c-9.591 5.962-21.716 6.041-31.384.204l-16.493-9.958c-19.567-11.814-44.076-11.784-63.614.079l-.846.513c-19.373 11.762-43.731 11.564-62.91-.512-19.601-11.835-44.146-11.835-63.747.001-19.601 11.836-44.146 11.836-63.747.001l-.002-.001c-20.072-11.621-44.878-11.392-64.733.596l-14.688 8.868c-9.963 6.016-22.44 6.016-32.403 0-20.888-12.615-47.544 2.428-47.544 26.83v217.421c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-217.424c0-24.583-27.011-39.596-47.889-26.618z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 261.753c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.89-12.614 47.545 2.429 47.545 26.831v179.773c0 11.267-9.133 20.4-20.4 20.4h-469.202c-11.267 0-20.4-9.133-20.4-20.4v-179.777c0-24.583 27.011-39.596 47.889-26.618z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 340.753c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.078l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.89-12.614 47.545 2.429 47.545 26.831v100.773c0 11.267-9.133 20.4-20.4 20.4h-469.202c-11.267 0-20.4-9.133-20.4-20.4v-100.777c0-24.582 27.011-39.595 47.889-26.617z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 396.374v71.773c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-71.773z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m468.891 170.706c0-4.999-3.39-9.895-8.544-10.627-26.397-3.752-30.993 25.66-25.792 28.688 5.2 3.026 7.505-10.289 21.087-7.414 6.679 1.414 11.691-2.41 12.99-8.284.175-.793.259-1.584.259-2.363z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494.403,
    cy: 196.162,
    fill: "url(#SVGID_6_)",
    r: 12.625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.032,
    cy: 154.604,
    fill: "url(#SVGID_7_)",
    r: 7.956
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 338.204,
    cy: 159.333,
    fill: "url(#SVGID_8_)",
    r: 12.685
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.333,
    cy: 186.258,
    fill: "url(#SVGID_9_)",
    r: 7.354
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m212.069 123.204c-5.689 0-10.301-4.612-10.301-10.301v-44.814c0-10.034-8.163-18.198-18.198-18.198-10.034 0-18.198 8.163-18.198 18.198v8.744c0 5.689-4.612 10.301-10.301 10.301s-10.301-4.612-10.301-10.301v-8.744c0-21.394 17.405-38.799 38.799-38.799s38.799 17.405 38.799 38.799v44.814c.001 5.689-4.61 10.301-10.299 10.301z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.57 37.492c-21.316 0-30.215 17.405-30.215 38.799v10.688c.56.094 1.131.154 1.717.154 5.689 0 10.301-4.612 10.301-10.301v-8.744c0-10.034 8.163-18.198 18.198-18.198 10.034 0 18.198 8.163 18.198 18.198v44.814c0 5.689 4.612 10.301 10.301 10.301.586 0 1.157-.06 1.717-.154v-46.758c-.002-21.394-8.901-38.799-30.217-38.799z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.069 123.204c-5.689 0-10.301-4.612-10.301-10.301v-23.826c0-21.394 17.405-38.799 38.799-38.799s38.799 17.405 38.799 38.799c0 5.689-4.612 10.301-10.301 10.301s-10.301-4.612-10.301-10.301c0-10.034-8.163-18.198-18.198-18.198s-18.198 8.163-18.198 18.198v23.827c.001 5.688-4.61 10.3-10.299 10.3z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m240.567 70.879c10.034 0 18.198 8.163 18.198 18.198 0 5.689 4.612 10.301 10.301 10.301 2.363 0 4.533-.804 6.271-2.142-1.992-20.841-15.973-37.044-32.881-37.044-18.27 0-33.134 8.584-33.134 42.161v20.47c.876.242 1.794.382 2.747.382 5.689 0 10.301-4.612 10.301-10.301v-23.827c-.001-10.035 8.163-18.198 18.197-18.198z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.361 58.777v63.483c-1.305.604-2.761.941-4.292.941-5.686 0-10.301-4.608-10.301-10.301v-23.825c0-12.244 5.707-23.183 14.593-30.298z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m257.225 33.573c-1.205 5.31-5.761 8.747-11.799 7.434-12.28-2.67-14.432 9.37-19.124 6.606-4.693-2.767-.387-29.366 23.488-25.839 4.661.689 7.705 5.137 7.681 9.662-.004.704-.084 1.42-.246 2.137z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.443,
    cy: 76.833,
    fill: "url(#SVGID_16_)",
    r: 8.314
  })), /*#__PURE__*/React.createElement("path", {
    d: "m487.66 242.053c-4.04 8.74-9.76 13.64-16.07 15.74-.78.27-1.56.49-2.36.67-11.64 2.61-24.75-3.46-32.82-11.89-13.99-14.62-25.23-9.84-35.95-.46-5.86-1.73-11.91-2.6-17.97-2.6-10.99 0-22 2.86-31.86 8.57-9.8 5.92-20.84 8.87-31.87 8.87-11.04 0-22.08-2.95-31.88-8.87s-20.84-8.88-31.87-8.88-22.07 2.96-31.87 8.88c-19.18 12.07-43.54 12.27-62.91.51l-.85-.52c-18.091-10.981-40.443-11.821-59.182-2.504-1.501.746-3.904.507-5.355 1.383l-19.288 7.286c-9.67 5.84-13.289 4.688-22.879-1.272-8.28-5.15-8.806-14.604-16.946-12.094-.28-3.47-.42-6.96-.42-10.49 0-13.391-3.283-11.926-7.636-25.139 18.661-60.016 79.717-104.021 152.156-104.021 66.74 0 123.81 37.35 146.97 90.17 6.23 14.2 20.09 23.52 35.59 23.52h.26c17.1 0 25.62-20.78 13.39-32.73-.13-.12-.26-.25-.4-.38-13.67-13.08-21.12-39.39 4.52-51.25 4.09-1.9 9.84 1.6 9.7 5.8-.22 6.52 2.78 15.42 16.1 23.44 24.95 15.01 23.17 17.73 17.47 34.98 17.26-5.69 19.98-7.47 34.99 17.48 8.02 13.32 16.92 16.32 23.44 16.1 4.2-.139 7.7 5.611 5.8 9.701z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.923 208.469c-3.978 12.519-6.113 25.741-6.113 39.414 0 3.53.14 7.02.42 10.49 8.14-2.51 17.38-1.77 25.66 3.38 9.59 5.96 21.71 6.04 31.38.2l16.5-9.95c1.432-.865 2.892-1.659 4.373-2.397-33.505-10.236-59.052-24.553-72.22-41.137z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.271,
    cy: 227.144,
    fill: "url(#SVGID_19_)",
    r: 16.729
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.41 246.573c8.07 8.43 21.18 14.5 32.82 11.89.8-.18 1.58-.4 2.36-.67 6.31-2.1 12.03-7 16.07-15.74 1.9-4.09-1.6-9.84-5.8-9.7-6.52.22-15.42-2.78-23.44-16.1-15.01-24.95-17.73-23.17-34.99-17.48 0 0-17.793 23.358-45.155 44.882 1.404-.094 2.81-.142 4.215-.142 6.06 0 12.11.87 17.97 2.6 10.72-9.38 21.96-14.16 35.95.46z",
    fill: "url(#SVGID_20_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhale);
export default __webpack_public_path__ + "static/media/icon-whale.d1e027b90dac506e74d41ad14479d7eb.svg";
export { ForwardRef as ReactComponent };